// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Flex,
//   IconButton,
//   Text,
//   Drawer,
//   DrawerOverlay,
//   DrawerContent,
//   DrawerCloseButton,
//   DrawerBody,
//   useDisclosure,
//   Tooltip,
//   VStack,
//   HStack,
//   Spacer,
//   useColorModeValue,
//   chakra,
//   Divider,
//   Avatar,
//   Badge,
//   Image,
//   Collapse,
//   Icon,
// } from "@chakra-ui/react";
// import { NavLink, useLocation } from "react-router-dom";
// import { FiChevronLeft, FiChevronRight, FiMenu } from "react-icons/fi";
// import agencyLogo from "assets/logo/logo.png";
// import { usePermissions } from "hooks/usePermissions";
// import { useIsMobile } from "hooks/useIsMobile";
// import { MdExpandLess, MdExpandMore } from "react-icons/md";
// import { sidebarFilterRoutes, safeStorage } from "./sidebarHelpers";

// // Storage keys
// const COLLAPSE_KEY = "app:sidebar:collapsed";

// const SidebarItem = React.memo(function SidebarItem({
//   route,
//   active,
//   collapsed,
//   onClick,
//   isMobile,
//   setCollapsed,
// }) {
//   const [open, setOpen] = useState(false);

//   const activeBg = useColorModeValue("brand.100", "brand.300");
//   const activeColor = useColorModeValue("brand.500", "gray.200");
//   const hoverBg = useColorModeValue("gray.50", "whiteAlpha.100");

//   const hasChildren =
//     Array.isArray(route.children) && route.children.length > 0;

//   const handleSidebarItemClick = () => {
//     if (hasChildren) {
//       // if collapsed, first expand the sidebar
//       if (collapsed && !isMobile) {
//         setCollapsed(false);
//         setOpen(true);
//       } else {
//         setOpen((prev) => !prev);
//       }
//     }
//     if (onClick && !hasChildren) onClick(); // only navigate if leaf
//   };

//   const content = (
//     <HStack
//       as={hasChildren ? "div" : NavLink}
//       to={hasChildren ? undefined : route.path}
//       onClick={handleSidebarItemClick}
//       align="center"
//       spacing={3}
//       px={3}
//       py={2.5}
//       borderRadius="lg"
//       _hover={{ bg: active ? activeBg : hoverBg }}
//       bg={active ? activeBg : "transparent"}
//       aria-current={active ? "page" : undefined}
//       role="link"
//       data-testid={`sidebar-link-${route.moduleId}`}
//       transition="background 200ms ease"
//       cursor="pointer"
//     >
//       <Box
//         as="span"
//         fontSize="sm"
//         color={active ? activeColor : "inherit"}
//         display="inline-flex"
//         alignItems="center"
//         justifyContent="center"
//         w="32px"
//       >
//         {/* {route.icon} */}
//         {/* <Icon as={route.icon} color={route.color} /> */}
//         <Icon as={route.icon} color={route.color} w="20px" h="20px" />
//       </Box>
//       {(!collapsed || isMobile) && (
//         <Box
//           as="span"
//           noOfLines={1}
//           fontWeight="600"
//           color={active ? activeColor : "inherit"}
//           fontSize="xs"
//           p={0}
//           m="0"
//           flex="1"
//           h="fit-content"
//         >
//           {route.name}
//           {route?.version && (
//             <Badge as="span" mx="2" colorScheme="green" fontSize="xs">
//               {route.version}
//             </Badge>
//           )}
//         </Box>
//       )}
//       {hasChildren && !collapsed && (
//         <Icon
//           as={open ? MdExpandLess : MdExpandMore}
//           boxSize={4}
//           color="text.muted"
//         />
//       )}
//     </HStack>
//   );

//   if (collapsed) {
//     return (
//       <Tooltip label={route.name} placement="right" openDelay={300} hasArrow>
//         <Box>{content}</Box>
//       </Tooltip>
//     );
//   }

//   return (
//     <Box>
//       {content}
//       {hasChildren && (
//         <Collapse in={open} animateOpacity>
//           <VStack align="start" pl={10} spacing={1} mt={1}>
//             {route.children.map((child, index) => (
//               <NavLink
//                 key={`${child?.id || child?.path || "unknown"}-${index}`}
//                 to={child.path}
//                 onClick={onClick}
//                 style={{ width: "100%" }}
//               >
//                 {({ isActive }) => (
//                   <Text
//                     px={2}
//                     py={1.5}
//                     fontSize="sm"
//                     borderRadius="md"
//                     color={isActive ? activeColor : "gray.600"}
//                     _hover={{ bg: hoverBg }}
//                     cursor={isActive ? "default" : "pointer"}
//                     onClick={(e) => {
//                       if (isActive) e.preventDefault();
//                       else onClick?.(e);
//                     }}
//                   >
//                     {child.name}
//                     {child?.version && (
//                       <Badge as="span" mx="2" colorScheme="green" fontSize="xs">
//                         {child.version}
//                       </Badge>
//                     )}
//                   </Text>
//                 )}
//               </NavLink>
//             ))}
//           </VStack>
//         </Collapse>
//       )}
//     </Box>
//   );
// });

// export default function AppSidebar({
//   routes,
//   brandName = "Dashboard",
//   onNavigate,
//   isMobileOpen: externalMobileOpen,
//   onMobileOpenChange,
// }) {
//   const location = useLocation();

//   const isMobile = useIsMobile(1024);

//   const [collapsed, setCollapsed] = useState(() => {
//     const stored = safeStorage.get(COLLAPSE_KEY);
//     return stored === "1";
//   });

//   useEffect(() => {
//     safeStorage.set(COLLAPSE_KEY, collapsed ? "1" : "0");
//   }, [collapsed]);

//   const { isOpen: internalOpen, onOpen, onClose } = useDisclosure();
//   const mobileOpen = externalMobileOpen ?? internalOpen;
//   const setMobileOpen = useCallback(
//     (open) => {
//       if (onMobileOpenChange) onMobileOpenChange(open);
//       else open ? onOpen() : onClose();
//     },
//     [onMobileOpenChange, onOpen, onClose],
//   );

//   const brandBg = useColorModeValue("brand.600", "brand.500");
//   const brandFg = useColorModeValue("white", "white");
//   const surface = useColorModeValue("white", "gray.900");
//   const border = useColorModeValue("gray.200", "whiteAlpha.200");

//   const EXPANDED_W = 270;
//   const COLLAPSED_W = 80;

//   const { hasPermission } = usePermissions();

//   const visibleRoutes = useMemo(() => {
//     return sidebarFilterRoutes(routes || [], hasPermission);
//   }, [routes, hasPermission]);

//   const handleNavigate = useCallback(() => {
//     // if (onNavigate) onNavigate();
//     if (isMobile) setMobileOpen(false);
//   }, [isMobile, setMobileOpen]);

//   const isActive = useCallback(
//     (path) => {
//       const currentPath = location.pathname.replace(/\/+$/, "");
//       const targetPath = path.replace(/\/+$/, "");

//       if (currentPath === targetPath) return true;

//       // match only if next char after targetPath is "/"
//       return currentPath.startsWith(targetPath + "/");
//     },
//     [location.pathname],
//   );

//   useEffect(() => {
//     const onKey = (e) => {
//       if (e.key === "[" && !isMobile) {
//         e.preventDefault();
//         setCollapsed((c) => !c);
//       }
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [isMobile]);

//   const Brand = (
//     <Flex
//       align="center"
//       minH="64px"
//       px={6}
//       borderBottomWidth="1px"
//       borderColor={border}
//     >
//       {agencyLogo ? (
//         <Image
//           src={agencyLogo}
//           alt="Logo"
//           h="32px"
//           objectFit="contain"
//           userSelect="none"
//         />
//       ) : (
//         <Flex
//           bg={brandBg}
//           color={brandFg}
//           w={8}
//           h={8}
//           align="center"
//           justify="center"
//           borderRadius="md"
//           flexShrink={0}
//           aria-label="Brand mark"
//         >
//           <chakra.span fontWeight="bold">W</chakra.span>
//         </Flex>
//       )}

//       {!collapsed && (
//         <HStack ml={3} spacing={2} minW={0}>
//           <Text fontWeight="bold" noOfLines={1}>
//             {brandName}
//           </Text>
//           {/* <Badge colorScheme='green'>PRO</Badge> */}
//         </HStack>
//       )}
//       <Spacer />
//       {!isMobile && (
//         <IconButton
//           aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
//           variant="ghost"
//           size="sm"
//           icon={collapsed ? <FiChevronRight /> : <FiChevronLeft />}
//           onClick={() => setCollapsed((c) => !c)}
//         />
//       )}
//       {/* {isMobile && (
// 				<IconButton
// 					aria-label='Close sidebar'
// 					variant='ghost'
// 					size='sm'
// 					icon={<FiChevronLeft />}
// 					onClick={() => setMobileOpen(false)}
// 				/>
// 			)} */}
//     </Flex>
//   );

//   const SidebarContent = (
//     <Flex direction="column" h="100%">
//       {Brand}
//       <Box
//         as="nav"
//         role="navigation"
//         aria-label="Main"
//         p={2}
//         w={"100%"}
//         overflowY="auto"
//         sx={{
//           "&::-webkit-scrollbar": {
//             width: "6px",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             background: "bg.elevated",
//             borderRadius: "10px",
//           },
//           "&::-webkit-scrollbar-thumb:hover": {
//             background: "gray.300",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "transparent",
//           },
//         }}
//       >
//         <VStack align="stretch" spacing={1}>
//           {visibleRoutes.map((r, index) => (
//             <SidebarItem
//               key={`${r?.moduleId || r?.id || r?.path || "unknown"}-${index}`}
//               route={r}
//               collapsed={collapsed}
//               active={isActive(r.path)}
//               onClick={handleNavigate}
//               isMobile={isMobile}
//               setCollapsed={setCollapsed}
//             />
//           ))}
//         </VStack>
//       </Box>
//       {/* <Divider /> */}
//       {/* <Flex align='center' p={3}>
// 				<Avatar size='sm' name='You' mr={collapsed ? 0 : 3} />
// 				{!collapsed && (
// 					<Box minW={0}>
// 						<Text fontSize='sm' noOfLines={1} fontWeight='600'>
// 							Naimat Ullah
// 						</Text>
// 						<Text fontSize='xs' color='text.muted' noOfLines={1}>
// 							MERN Developer
// 						</Text>
// 					</Box>
// 				)}
// 			</Flex> */}
//     </Flex>
//   );
//   // Mobile view
//   const MobileOpenButton = (
//     <IconButton
//       aria-label="Open menu"
//       icon={<FiMenu />}
//       variant="ghost"
//       onClick={() => setMobileOpen(true)}
//     />
//   );

//   if (isMobile) {
//     return (
//       <>
//         {/* {MobileOpenButton} */}
//         <Drawer
//           isOpen={mobileOpen}
//           placement="left"
//           onClose={() => setMobileOpen(false)}
//           size="xs"
//         >
//           <DrawerOverlay />
//           <DrawerContent bg={surface}>
//             <DrawerCloseButton />
//             <DrawerBody p={0}>{SidebarContent}</DrawerBody>
//           </DrawerContent>
//         </Drawer>
//       </>
//     );
//   }

//   return (
//     <Box
//       display={{ base: "none", lg: "block" }}
//       as="aside"
//       bg={surface}
//       borderRightWidth="1px"
//       borderRightColor={border}
//       position="sticky"
//       top="0"
//       h="100vh"
//       // top='56px'
//       // h='calc(100dvh - 56px)'
//       w={{
//         base: collapsed ? `${COLLAPSED_W}px` : `${EXPANDED_W}px`,
//       }}
//       transition="width 220ms cubic-bezier(.4,0,.2,1)"
//       willChange="width"
//       zIndex={20}
//     >
//       {SidebarContent}
//     </Box>
//   );
// }

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
	Box,
	Flex,
	IconButton,
	Text,
	Drawer,
	DrawerOverlay,
	DrawerContent,
	DrawerCloseButton,
	DrawerBody,
	useDisclosure,
	Tooltip,
	VStack,
	HStack,
	Spacer,
	useColorModeValue,
	chakra,
	Badge,
	Image,
	Collapse,
	Icon,
} from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight, FiMenu } from 'react-icons/fi';
import BrandLogo from 'assets/logo/logo.png';
import { usePermissions } from 'hooks/usePermissions';
import { useIsMobile } from 'hooks/useIsMobile';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { sidebarFilterRoutes, safeStorage } from './sidebarHelpers';
import useUserSession from 'hooks/useUserSession';
import { toCapitalCase } from 'utils/helpers';
import defaultLogo from 'assets/img/logo-crm-1.png';


// Storage keys
const COLLAPSE_KEY = 'app:sidebar:collapsed';

// const SidebarItem = React.memo(function SidebarItem({
//   route,
//   active,
//   collapsed,
//   onClick,
//   isMobile,
//   setCollapsed,
//   isOpen,
//   onToggle,
//   onCloseOtherRoutes,
// }) {
//   const activeBg = useColorModeValue("brand.100", "brand.300");
//   const activeColor = useColorModeValue("brand.500", "gray.200");
//   const hoverBg = useColorModeValue("gray.50", "whiteAlpha.100");

//   const hasChildren =
//     Array.isArray(route.children) && route.children.length > 0;

//   const handleSidebarItemClick = (e) => {
//     if (hasChildren) {
//       e.preventDefault();

//       // If this route is already open, close it
//       if (isOpen) {
//         if (onToggle) onToggle();
//       } else {
//         // Close other routes first when opening this one
//         if (onCloseOtherRoutes) {
//           onCloseOtherRoutes();
//         }

//         // if collapsed, first expand the sidebar
//         if (collapsed && !isMobile) {
//           setCollapsed(false);
//           // We'll open this after a short delay to allow the sidebar to expand
//           setTimeout(() => {
//             if (onToggle) onToggle();
//           }, 50);
//         } else {
//           if (onToggle) onToggle();
//         }
//       }
//     }
//     if (onClick && !hasChildren) onClick(); // only navigate if leaf
//   };

//   const content = (
//     <HStack
//       as={hasChildren ? "div" : NavLink}
//       to={hasChildren ? undefined : route.path}
//       onClick={handleSidebarItemClick}
//       align="center"
//       spacing={3}
//       px={3}
//       py={2.5}
//       borderRadius="lg"
//       _hover={{ bg: active ? activeBg : hoverBg }}
//       bg={active ? activeBg : "transparent"}
//       aria-current={active ? "page" : undefined}
//       role="link"
//       data-testid={`sidebar-link-${route.moduleId}`}
//       transition="background 200ms ease"
//       cursor="pointer"
//     >
//       <Box
//         as="span"
//         fontSize="sm"
//         color={active ? activeColor : "inherit"}
//         display="inline-flex"
//         alignItems="center"
//         justifyContent="center"
//         w="32px"
//       >
//         <Icon as={route.icon} color={"brand.600"} w="20px" h="20px" />
//       </Box>
//       {(!collapsed || isMobile) && (
//         <Box
//           as="span"
//           noOfLines={1}
//           fontWeight="600"
//           color={active ? activeColor : "inherit"}
//           fontSize="xs"
//           p={0}
//           m="0"
//           flex="1"
//           h="fit-content"
//         >
//           {route.name}
//           {route?.version && (
//             <Badge as="span" mx="2" colorScheme="green" fontSize="xs">
//               {route.version}
//             </Badge>
//           )}
//         </Box>
//       )}
//       {hasChildren && !collapsed && (
//         <Icon
//           as={isOpen ? MdExpandLess : MdExpandMore}
//           boxSize={4}
//           color="text.muted"
//         />
//       )}
//     </HStack>
//   );

//   if (collapsed) {
//     return (
//       <Tooltip label={route.name} placement="right" openDelay={300} hasArrow>
//         <Box>{content}</Box>
//       </Tooltip>
//     );
//   }

//   return (
//     <Box>
//       {content}
//       {hasChildren && (
//         <Collapse in={isOpen} animateOpacity>
//           <VStack align="start" pl={10} spacing={1} mt={1}>
//             {route.children.map((child, index) => (
//               <NavLink
//                 key={`${child?.id || child?.path || "unknown"}-${index}`}
//                 to={child.path}
//                 onClick={() => {
//                   // When a child route is clicked, close all other open routes
//                   if (onCloseOtherRoutes) {
//                     onCloseOtherRoutes();
//                   }
//                   onClick?.();
//                 }}
//                 style={{ width: "100%" }}
//               >
//                 {({ isActive }) => (
//                   <Text
//                     px={2}
//                     py={1.5}
//                     fontSize="sm"
//                     borderRadius="md"
//                     // color={isActive ? activeColor : "gray.600"}
//                     color={"text.secondary"}
//                     bg={isActive ? hoverBg : "transparent"}
//                     _hover={{ bg: hoverBg }}
//                     cursor={isActive ? "default" : "pointer"}
//                     onClick={(e) => {
//                       if (isActive) e.preventDefault();
//                       else onClick?.(e);
//                     }}
//                   >
//                     {child.name}
//                     {child?.version && (
//                       <Badge as="span" mx="2" colorScheme="green" fontSize="xs">
//                         {child.version}
//                       </Badge>
//                     )}
//                   </Text>
//                 )}
//               </NavLink>
//             ))}
//           </VStack>
//         </Collapse>
//       )}
//     </Box>
//   );
// });

// Category Component with collapsible functionality

const SidebarItem = React.memo(function SidebarItem({
	route,
	active,
	collapsed,
	onClick,
	isMobile,
	setCollapsed,
	isOpen,
	onToggle,
	onCloseOtherRoutes,
}) {
	// Single-root semantic tokens → gold-accent active state, adapts to both themes
	const activeBg = 'accent.subtle';
	const activeColor = 'text.accent';
	const hoverBg = 'bg.elevated';

	const { agencyLogo } = useUserSession();
	const hasChildren =
		Array.isArray(route.children) && route.children.length > 0;

	const handleSidebarItemClick = (e) => {
		if (hasChildren) {
			e.preventDefault();

			// If this route is already open, close it
			if (isOpen) {
				if (onToggle) onToggle();
			} else {
				// Close other routes first when opening this one
				if (onCloseOtherRoutes) {
					onCloseOtherRoutes();
				}

				// if collapsed, first expand the sidebar
				if (collapsed && !isMobile) {
					setCollapsed(false);
					// We'll open this after a short delay to allow the sidebar to expand
					setTimeout(() => {
						if (onToggle) onToggle();
					}, 50);
				} else {
					if (onToggle) onToggle();
				}
			}
		}
		if (onClick && !hasChildren) onClick(); // only navigate if leaf
	};

	const content = (
		<HStack
			as={hasChildren ? 'div' : NavLink}
			to={hasChildren ? undefined : route.path}
			onClick={handleSidebarItemClick}
			align='center'
			spacing={3}
			px={3}
			py={2.5}
			borderRadius='lg'
			color={active ? activeColor : 'text.body'}
			_hover={{ bg: active ? activeBg : hoverBg, color: activeColor }}
			bg={active ? activeBg : 'transparent'}
			aria-current={active ? 'page' : undefined}
			role='link'
			data-testid={`sidebar-link-${route.moduleId}`}
			transition='background 200ms ease'
			cursor='pointer'
		>
			<Box
				as='span'
				fontSize='sm'
				color={active ? activeColor : 'text.secondary'}
				display='inline-flex'
				alignItems='center'
				justifyContent='center'
				w='32px'
			>
				<Icon
					as={route.icon}
					color={active ? activeColor : route?.color || 'text.secondary'}
					w='20px'
					h='20px'
				/>
			</Box>
			{(!collapsed || isMobile) && (
				<Box
					as='span'
					noOfLines={1}
					fontWeight='600'
					color={active ? activeColor : 'text.body'}
					// color={route.color || 'inherit'}

					fontSize={{ base: 'xs' }}
					p={0}
					m='0'
					flex='1'
					h='fit-content'
				>
					{route.name}
					{route?.version && (
						<Badge as='span' mx='2' colorScheme='green' fontSize='xs'>
							{route.version}
						</Badge>
					)}
				</Box>
			)}
			{hasChildren && !collapsed && (
				<Icon
					as={isOpen ? MdExpandLess : MdExpandMore}
					boxSize={4}
					color='text.muted'
				/>
			)}
		</HStack>
	);

	if (collapsed) {
		return (
			<Tooltip label={route.name} placement='right' openDelay={300} hasArrow>
				<Box>{content}</Box>
			</Tooltip>
		);
	}

	return (
		<Box color='text.body'>
			{content}
			{hasChildren && (
				<Collapse in={isOpen} animateOpacity>
					<VStack align='start' pl={10} spacing={1} mt={1}>
						{route.children.map((child, index) => (
							<NavLink
								key={`${child?.id || child?.path || 'unknown'}-${index}`}
								to={child.path}
								onClick={() => {
									// ONLY navigate, DO NOT close other routes
									onClick?.();
								}}
								style={{ width: '100%' }}
							>
								{({ isActive }) => (
									<Text
										px={2}
										py={1.5}
										fontSize='sm'
										borderRadius='md'
										color={isActive ? activeColor : 'text.body'}
										bg={isActive ? hoverBg : 'transparent'}
										_hover={{ bg: hoverBg }}
										cursor={isActive ? 'default' : 'pointer'}
										onClick={(e) => {
											if (isActive) e.preventDefault();
											else onClick?.(e);
										}}
									>
										{child.name}
										{child?.version && (
											<Badge as='span' mx='2' colorScheme='green' fontSize='xs'>
												{child.version}
											</Badge>
										)}
									</Text>
								)}
							</NavLink>
						))}
					</VStack>
				</Collapse>
			)}
		</Box>
	);
});
const CategorySection = React.memo(function CategorySection({
	category,
	collapsed,
	isMobile,
	setCollapsed,
	handleNavigate,
	isActive,
	openRouteId,
	onToggleRoute,
	onCloseOtherRoutes,
}) {
	const [isCategoryOpen, setIsCategoryOpen] = useState(true);
	const hoverBg = 'bg.elevated';

	const handleCategoryClick = () => {
		setIsCategoryOpen(!isCategoryOpen);
	};

	return (
		<Box mb={4}>
			{/* Category Header - collapsible by user */}
			{!collapsed || isMobile ? (
				<HStack
					px={3}
					py={2}
					mb={2}
					cursor='pointer'
					onClick={handleCategoryClick}
					borderRadius='md'
					_hover={{ bg: hoverBg, color: 'text.accent' }}
				>
					<Text
						fontWeight='bold'
						fontSize={{ base: 'xs', md: 'sm' }}
						color='text.body'
						letterSpacing='wide'
					>
						{category.category}
					</Text>
					<Icon
						as={isCategoryOpen ? MdExpandLess : MdExpandMore}
						boxSize={3}
						color='text.muted'
					/>
				</HStack>
			) : (
				<Tooltip
					label={category.category}
					placement='right'
					openDelay={300}
					hasArrow
				>
					<Box
						px={3}
						py={2}
						mb={2}
						cursor='pointer'
						onClick={handleCategoryClick}
					>
						<Box w='32px' h='2px' bg='gray.300' borderRadius='full' mx='auto' />
					</Box>
				</Tooltip>
			)}

			{/* Category Routes - collapsible based on isCategoryOpen */}
			<Collapse in={isCategoryOpen || collapsed} animateOpacity>
				<VStack align='stretch' spacing={1}>
					{category.routes.map((route, index) => {
						const routeId = `${category.category}-${route.path || route.name || index}`;
						const isRouteOpen = openRouteId === routeId;
						const hasChildren =
							Array.isArray(route.children) && route.children.length > 0;

						// Only routes with children should have toggle functionality
						const handleToggle = () => {
							if (hasChildren) {
								onToggleRoute(routeId);
							}
						};

						return (
							<SidebarItem
								key={`${route?.moduleId || route?.id || route?.path || 'unknown'}-${index}`}
								route={route}
								collapsed={collapsed}
								// A group is active when the current page is one of ITS
								// children, not only when the URL shares its prefix —
								// Meta WhatsApp lives under the WhatsApp group at
								// /meta-whatsapp.
								active={
									isActive(route.path) ||
									(route.children || []).some((child) => isActive(child.path))
								}
								onClick={handleNavigate}
								isMobile={isMobile}
								setCollapsed={setCollapsed}
								isOpen={isRouteOpen}
								onToggle={handleToggle}
								onCloseOtherRoutes={onCloseOtherRoutes}
							/>
						);
					})}
				</VStack>
			</Collapse>
		</Box>
	);
});

export default function AppSidebar({
	routes,
	brandName = 'Dashboard',
	onNavigate,
	isMobileOpen: externalMobileOpen,
	onMobileOpenChange,
}) {
	const location = useLocation();

	const isMobile = useIsMobile(1024);

	const [collapsed, setCollapsed] = useState(() => {
		const stored = safeStorage.get(COLLAPSE_KEY);
		return stored === '1';
	});

	// State to track which route (with children) is open
	const [openRouteId, setOpenRouteId] = useState(null);

	useEffect(() => {
		safeStorage.set(COLLAPSE_KEY, collapsed ? '1' : '0');
	}, [collapsed]);

	const { isOpen: internalOpen, onOpen, onClose } = useDisclosure();
	const mobileOpen = externalMobileOpen ?? internalOpen;
	const setMobileOpen = useCallback(
		(open) => {
			if (onMobileOpenChange) onMobileOpenChange(open);
			else open ? onOpen() : onClose();
		},
		[onMobileOpenChange, onOpen, onClose],
	);

	const surface = 'bg.sidebar';
	const border = 'border.subtle';

	const EXPANDED_W = 270;
	const COLLAPSED_W = 80;

	const { hasPermission } = usePermissions();

	// const visibleRoutes = useMemo(() => {
	//   console.log('Processing routes:', routes);

	//   // If routes have category structure
	//   if (routes && routes.length > 0 && routes[0]?.category !== undefined) {
	//     const filteredCategories = [];

	//     for (const category of routes) {
	//       console.log(`Processing category: ${category.category}`);

	//       if (category.routes && category.routes.length > 0) {
	//         const flatRoutes = [...category.routes];
	//         console.log(`Flat routes for ${category.category}:`, flatRoutes.map(r => ({
	//           name: r.name,
	//           moduleId: r.moduleId,
	//           hasChildren: !!r.children?.length
	//         })));

	//         // Step 1: Use the working sidebarFilterRoutes function
	//         const filteredFlatRoutes = sidebarFilterRoutes(flatRoutes, hasPermission);
	//         console.log(`Filtered flat routes for ${category.category}:`, filteredFlatRoutes);

	//         // Step 2: Create a Set of filtered route paths
	//         const filteredPaths = new Set();
	//         const addPaths = (route) => {
	//           filteredPaths.add(route.path);
	//           if (route.children) {
	//             route.children.forEach(child => addPaths(child));
	//           }
	//         };
	//         filteredFlatRoutes.forEach(route => addPaths(route));

	//         // Step 3: Filter the original routes
	//         const filteredRoutes = category.routes
	//           .map(route => {
	//             // Check if this route exists in filtered results
	//             const filteredRoute = filteredFlatRoutes.find(fr => fr.path === route.path);

	//             if (filteredRoute) {
	//               return filteredRoute;
	//             }

	//             // If route has children, check if any children are visible
	//             if (route.children && route.children.length > 0) {
	//               const visibleChildren = route.children.filter(child =>
	//                 filteredPaths.has(child.path)
	//               );

	//               if (visibleChildren.length > 0) {
	//                 return {
	//                   ...route,
	//                   children: visibleChildren,
	//                   isContainerOnly: true
	//                 };
	//               }
	//             }

	//             return null;
	//           })
	//           .filter(Boolean);

	//         console.log(`Final routes for ${category.category}:`, filteredRoutes);

	//         // Only add category if it has visible routes
	//         if (filteredRoutes.length > 0) {
	//           filteredCategories.push({
	//             ...category,
	//             routes: filteredRoutes,
	//           });
	//         } else {
	//           console.log(`Category ${category.category} has no visible routes, removing`);
	//         }
	//       }
	//     }

	//     // ✅ IMPORTANT: Return the filtered categories
	//     console.log('Final filtered categories:', filteredCategories);
	//     return filteredCategories;
	//   }

	//   // Fallback for flat routes structure
	//   console.log('Using flat routes structure');
	//   return sidebarFilterRoutes(routes || [], hasPermission);
	// }, [routes, hasPermission]);

	// Function to close all routes (with children)
	const visibleRoutes = useMemo(() => {
		if (!routes || routes.length === 0) return [];

		// Check if ANY item has category (not just the first one)
		const hasCategories = routes.some((route) => route.category !== undefined);

		if (hasCategories) {
			const filteredCategories = [];

			for (const item of routes) {
				// Handle standalone routes (like Dashboard)
				if (item.category === undefined) {
					// This is a standalone route, filter it directly
					const filteredStandalone = sidebarFilterRoutes([item], hasPermission);
					if (filteredStandalone.length > 0) {
						// Add it as a standalone item (not wrapped in category)
						filteredCategories.push(...filteredStandalone);
					}
					continue;
				}

				// Handle categories

				if (item.routes && item.routes.length > 0) {
					const flatRoutes = [...item.routes];

					// Use sidebarFilterRoutes to filter the routes
					const filteredFlatRoutes = sidebarFilterRoutes(
						flatRoutes,
						hasPermission,
					);

					// Create a Set of filtered route paths
					const filteredPaths = new Set();
					const addPaths = (route) => {
						filteredPaths.add(route.path);
						if (route.children) {
							route.children.forEach((child) => addPaths(child));
						}
					};
					filteredFlatRoutes.forEach((route) => addPaths(route));

					// Filter the original routes
					const filteredRoutes = item.routes
						.map((route) => {
							const filteredRoute = filteredFlatRoutes.find(
								(fr) => fr.path === route.path,
							);
							if (filteredRoute) return filteredRoute;

							if (route.children && route.children.length > 0) {
								const visibleChildren = route.children.filter((child) =>
									filteredPaths.has(child.path),
								);
								if (visibleChildren.length > 0) {
									return {
										...route,
										children: visibleChildren,
										isContainerOnly: true,
									};
								}
							}
							return null;
						})
						.filter(Boolean);

					if (filteredRoutes.length > 0) {
						filteredCategories.push({
							...item,
							routes: filteredRoutes,
						});
					}
				}
			}

			return filteredCategories;
		}

		// Fallback for flat routes structure
		return sidebarFilterRoutes(routes || [], hasPermission);
	}, [routes, hasPermission]);
	const closeAllRoutes = useCallback(() => {
		setOpenRouteId(null);
	}, []);

	// Function to toggle a specific route and close others
	const toggleRoute = useCallback((routeId) => {
		setOpenRouteId((prev) => (prev === routeId ? null : routeId));
	}, []);

	const handleNavigate = useCallback(() => {
		if (isMobile) setMobileOpen(false);
	}, [isMobile, setMobileOpen]);

	const isActive = useCallback(
		(path) => {
			if (!path) return false;
			const currentPath = location.pathname.replace(/\/+$/, '');
			const targetPath = path.replace(/\/+$/, '');

			if (currentPath === targetPath) return true;

			// match only if next char after targetPath is "/"
			return currentPath.startsWith(targetPath + '/');
		},
		[location.pathname],
	);

	useEffect(() => {
		const onKey = (e) => {
			if (e.key === '[' && !isMobile) {
				e.preventDefault();
				setCollapsed((c) => !c);
			}
		};
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	}, [isMobile]);
	const { agencyLogo } = useUserSession();
	const [isImageError, setIsImageError] = useState(false);


	const logoSrc = !isImageError && agencyLogo ? agencyLogo : defaultLogo;

	const handleLogoError = useCallback(() => {
		setIsImageError(true);
	}, []);


	const Brand = (
		<Flex
			align='center'
			minH='64px'
			px={6}
			borderBottomWidth='1px'
			borderColor={border}
		>
			<Box
				maxW={'24px'}
				maxH={'24px'}
				borderRadius="lg"
				overflow="hidden"
				display="flex"
				alignItems="center"
				justifyContent="center"
			>
				<Image
					src={logoSrc}
					alt={`${brandName || "CRM"} Logo`}
					w="100%"
					h="100%"
					objectFit="contain"
					fallbackSrc={defaultLogo}
					onError={handleLogoError}
				/>
			</Box>



			{!collapsed && (
				<HStack ml={3} spacing={2} minW={0}>
					<Text textTransform='capitalize' fontWeight='bold' noOfLines={1}>
						{brandName}
					</Text>
				</HStack>
			)}
			<Spacer />
			{!isMobile && (
				<IconButton
					aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
					variant='ghost'
					size='sm'
					icon={collapsed ? <FiChevronRight /> : <FiChevronLeft />}
					onClick={() => setCollapsed((c) => !c)}
				/>
			)}
		</Flex>
	);

	const SidebarContent = (
		<Flex direction='column' h='100%' bg='bg.sidebar'>
			{Brand}
			<Box
				as='nav'
				role='navigation'
				aria-label='Main'
				p={2}
				w={'100%'}
				overflowY='auto'
				sx={{
					'&::-webkit-scrollbar': {
						width: '6px',
					},
					'&::-webkit-scrollbar-thumb': {
						background: 'bg.elevated',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						background: 'gray.300',
					},
					'&::-webkit-scrollbar-track': {
						background: 'transparent',
					},
				}}
			>
				<VStack align='stretch' spacing={2}>
					{visibleRoutes.map((item, index) => {
						// Check if this is a category (has category property) or a flat route
						if (item.category !== undefined) {
							// This is a category with routes - categories are collapsible
							return (
								<CategorySection
									key={`category-${item.category}-${index}`}
									category={item}
									collapsed={collapsed}
									isMobile={isMobile}
									setCollapsed={setCollapsed}
									handleNavigate={handleNavigate}
									isActive={isActive}
									openRouteId={openRouteId}
									onToggleRoute={toggleRoute}
									onCloseOtherRoutes={closeAllRoutes}
								/>
							);
						} else {
							// This is a flat route (might have children)
							const hasChildren =
								Array.isArray(item.children) && item.children.length > 0;
							const routeId = `flat-${item.path || item.name || index}`;
							const isRouteOpen = openRouteId === routeId;

							// Only routes with children should have toggle functionality
							const handleToggle = () => {
								if (hasChildren) {
									toggleRoute(routeId);
								}
							};

							return (
								<SidebarItem
									key={`${item?.moduleId || item?.id || item?.path || 'unknown'}-${index}`}
									route={item}
									collapsed={collapsed}
									active={isActive(item.path)}
									onClick={handleNavigate}
									isMobile={isMobile}
									setCollapsed={setCollapsed}
									isOpen={isRouteOpen}
									onToggle={handleToggle}
									onCloseOtherRoutes={closeAllRoutes}
								/>
							);
						}
					})}
				</VStack>
			</Box>
		</Flex>
	);

	// Mobile view
	if (isMobile) {
		return (
			<>
				<Drawer
					isOpen={mobileOpen}
					placement='left'
					onClose={() => setMobileOpen(false)}
					size='xs'
				>
					<DrawerOverlay />
					<DrawerContent bg={surface}>
						<DrawerCloseButton />
						<DrawerBody p={0}>{SidebarContent}</DrawerBody>
					</DrawerContent>
				</Drawer>
			</>
		);
	}

	return (
		<Box
			display={{ base: 'none', lg: 'block' }}
			as='aside'
			bg={surface}
			borderRightWidth='1px'
			borderRightColor={border}
			position='sticky'
			top='0'
			h='100vh'
			w={{
				base: collapsed ? `${COLLAPSED_W}px` : `${EXPANDED_W}px`,
			}}
			transition='width 220ms cubic-bezier(.4,0,.2,1)'
			willChange='width'
			zIndex={20}
		>
			{SidebarContent}
		</Box>
	);
}


// {agencyLogo ? (
// 			<Image
// 				src={agencyLogo}
// 				alt='Logo'
// 				h='32px'
// 				objectFit='contain'
// 				userSelect='none'
// 			/>
// 		) : (
// 			<Flex
// 				bg={brandBg}
// 				color={brandFg}
// 				w={8}
// 				h={8}
// 				align='center'
// 				justify='center'
// 				borderRadius='md'
// 				flexShrink={0}
// 				aria-label='Brand mark'
// 			>
// 				<chakra.span fontWeight='bold'>
// 					{brandName?.trim()?.[0]?.toUpperCase() || 'W'}
// 				</chakra.span>
// 			</Flex>
// 		)}